<template>
  <div class="recharge-people-choice" v-if="isShown">
    <!-- 充值账户-自己 -->
    <div class="recharge-people recharge-ourself" @click="onSelectSelf">
      <img v-once :src="avatar" alt="" class="recharge-logo" />
      <p class="recharge-name">
        自己(<span>{{ selfNickName }}</span
        >)
      </p>
      <i class="arrow-right"></i>
    </div>
    <!-- 充值账户-好友 -->
    <div class="recharge-people recharge-friend" @click="onSelectFriends">
      <img src="../../../ui/assets/mobile/images/friend.png" alt="" class="recharge-logo" />
      <p class="recharge-name">我的好友</p>
      <i class="arrow-right"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "FriendsSelector",
  props: ["isShown", "onSelectSelf", "onSelectFriends", "selfNickName", "avatar"]
}
</script>

<style scoped></style>
